(function () {
  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getDiscountElement(drawer) {
    return drawer ? drawer.querySelector('cart-discount-element') : null;
  }

  function applyPromoCode(code) {
    const drawer = getCartDrawer();
    const discountEl = getDiscountElement(drawer);
    if (!discountEl || !code) return;

    const input = discountEl.querySelector('.cart-discount');
    const applyBtn = discountEl.querySelector('.apply-discount');
    if (!input || !applyBtn) return;

    input.value = code;
    applyBtn.click();
  }

  function expandDiscountSection() {
    const discountEl = getDiscountElement(getCartDrawer());
    if (!discountEl || discountEl.classList.contains('open')) return;

    const content = discountEl.querySelector('.cart-addons-content');
    discountEl.classList.add('open', 'cart-drawer-pro-discount--expanded');
    if (content) {
      content.style.height = 'auto';
      content.classList.remove('visibility-hidden', 'h-0');
    }
  }

  function getExistingDiscountCodes(drawer) {
    const codes = [];
    if (!drawer) return codes;
    drawer.querySelectorAll('[data-discount-code]').forEach(function (el) {
      var code = el.dataset.discountCode;
      if (code && codes.indexOf(code) === -1) codes.push(code);
    });
    return codes;
  }

  function removePromoCode(code) {
    var drawer = getCartDrawer();
    if (!drawer || !code || typeof routes === 'undefined') return;

    var filtered = getExistingDiscountCodes(drawer).filter(function (c) {
      return c.toUpperCase() !== code.toUpperCase();
    });

    fetch(routes.cart_update_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        discount: filtered.join(','),
        sections: [drawer.dataset.sectionId, 'cart-icon-bubble'],
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (typeof drawer.renderContents === 'function') {
          drawer.renderContents(response);
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function (e) {
        console.error(e);
      });
  }

  document.addEventListener('click', function (event) {
    var promoBtn = event.target.closest('[data-apply-promo]');
    if (promoBtn) {
      event.preventDefault();
      if (promoBtn.classList.contains('loading')) return;
      promoBtn.classList.add('loading');
      applyPromoCode(promoBtn.dataset.applyPromo);
      window.setTimeout(function () {
        promoBtn.classList.remove('loading');
      }, 2500);
      return;
    }

    var removeBtn = event.target.closest('[data-remove-promo]');
    if (removeBtn) {
      event.preventDefault();
      removePromoCode(removeBtn.dataset.removePromo);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('[data-discount-expanded="true"]')) {
      expandDiscountSection();
    }
  });

  document.addEventListener('cart:updated', function () {
    if (document.querySelector('[data-discount-expanded="true"]')) {
      expandDiscountSection();
    }
  });
})();
